module.exports = ".spacer {\r\n    margin: 5px;\r\n}"